import { assert } from './assert-sidecar'
import { l } from './imports'

export function t(condition: boolean, ...error: any[]): asserts condition {
  if (!condition) {
    let message = 'ERROR assert failed'
    let fullMessage = ''
    for (let i = 0; i < error.length; i++) {
      fullMessage += '|'
      fullMessage += error[i]
    }

    console.error(message, ...error)
    throw new Error(message + fullMessage)
  }
}
export function f(
  condition: boolean,
  ...error: any[]
): asserts condition is false {
  t(!condition, ...error)
}
export function nil(
  item: any,
  ...error: any[]
): asserts item is null | undefined {
  t(item === null || item === undefined, 'nil', ...error)
}
export function notNil(item: any, ...error: any[]): asserts item {
  t(item !== null && item !== undefined, 'notNil', ...error)
}
export function notEmpty(item: any[], ...error: any[]): asserts item {
  t(item != null && item.length > 0, 'notEmpty', ...error)
}
export function notUndefined(item: any, ...error: any[]): asserts item {
  t(item !== undefined, 'notUndefined', ...error)
}
export function notEmptyString(
  item: string | null | undefined,
  ...error: any[]
): asserts item {
  t(
    item != null && item != '' && item.trim().length > 0,
    'notEmptyString',
    ...error,
  )
}
export function inRange(v: number, min: number, max: number, ...error: any[]) {
  assert.t(v >= min && v <= max, 'range error', v, min, max, ...error)
}

export function onlyOneIsNotNil(a: any, b: any, ...error: any[]) {
  f(a == null && b == null, 'both nil', ...error)
  f(a != null && b != null, 'both not nil', ...error)
}

export function notIn(array: any[], item: any, ...error: any[]) {
  t(!l.includes(array, item), 'notIn', ...error)
}

export function isIn(array: any[], item: any, ...error: any[]) {
  t(l.includes(array, item), 'isIn', ...error)
}
export function eq<T>(a: T, b: T, ...error: any[]) {
  t(a === b, 'eq', a, b, ...error)
}

export function eqFuzzy<T>(a: T, b: T, ...error: any[]) {
  if (l.isNumber(a) && l.isNumber(b)) {
    t(Math.abs(a - b) < 0.01, a, b, ...error)
  } else {
    t(a === b, 'eq', a, b, ...error)
  }
}

export function notEq<T>(a: T, b: T, ...error: any[]) {
  t(a !== b, 'not-eq', ...error)
}
export function failed(...error: any[]) {
  t(false, ...error)
}
export function loopLimit(loopCount: number, max: number, ...error: any[]) {
  if (loopCount > max) {
    t(false, 'loop hit limit', max, ...error)
  }
}
export function shouldNotExecute(...error: any[]): never {
  failed('should not excute', ...error)
  throw new Error('Unreachable code')
}

export function assertIsByte(v: number, ...erro: any[]) {
  t(v >= -128 && v <= 127, 'byte out of range', v)
}
export function assertIsByteUnsigned(v: number, ...erro: any[]) {
  t(v >= 0 && v <= 255, 'ubyte out of range', v)
}
export function assertIsInt16(v: number, ...erro: any[]) {
  t(v >= -32768 && v <= 32767, 'Int16 out of range', v)
}

const _verboseDeepSlow = false
export function deepEqSlow(a: any, b: any, ...error: any[]) {
  let keys = Object.keys(a)
  let keys2 = Object.keys(b)
  assert.eq(keys.length, keys2.length, 'different keys', error)

  l.forEach(keys, (c) => {
    let a1 = a[c]
    let b1 = b[c]

    if (_verboseDeepSlow) {
      console.log('test a1 vs b1', c, a1, b1)
    }

    if (l.isArray(a1)) {
      _deepEqArray(a1, b1, c, ...error)
    } else if (l.isObject(a1)) {
      assert.failed('cant do this deep get', c, a1, ...error)
    } else {
      assert.eqFuzzy(a1, b1, ...error)
    }
  })
}

function _deepEqArray(a1: any[], b1: any[], key: string, ...error: any[]) {
  assert.eq(a1.length, b1.length, key, 'array different lengths', ...error)
  for (let i = 0; i < a1.length; i++) {
    let vArrA = a1[i]
    let vArrB = b1[i]

    if (_verboseDeepSlow) {
      console.log('test a1 vs b1', key, i, vArrA, vArrB)
    }

    if (l.isArray(vArrA)) {
      _deepEqArray(vArrA, vArrB, key + '|' + i, ...error)
    } else if (l.isObject(vArrA)) {
      assert.failed('cant do this deep get', key, vArrA, ...error)
    } else {
      assert.eqFuzzy(vArrA, vArrB, key, ...error)
    }
  }
}
